import { emailValidations } from './emailValidations';

export const workspace = ($http: HttpApi) => ({
  emailValidations: emailValidations($http),
});
